import "./EcommerceSeo.module.css";
import Header from "@/reusable_sections/Header";
import Ecommerce from "./sections/Ecommerce";
import EcommerceOverview from "./sections/EcommerceOverview";
import EcommercePillars from "./sections/EcommercePillars";
import KeywordIntent from "./sections/KeywordIntent";
import ProductCategorySeo from "./sections/ProductCategorySeo";
import TechnicalEcommerce from "./sections/TechnicalEcommerce";
import Platforms from "./sections/Platforms";
import ContentCompetitors from "./sections/ContentCompetitors";
import Measurement from "./sections/Measurement";
import AiDiscovery from "./sections/AiDiscovery";
import Process from "./sections/Process";
import DirectConsultant from "./sections/DirectConsultant";
import Faq from "./sections/Faq";
import Ecommerceaudit from "./sections/Ecommerceaudit";
import Footer from "@/reusable_sections/Footer";

// Ecommerce SEO page entry: sections render in order from Header to Footer.
export default function EcommerceSeoPage() {
  return <div>
      <Header />
      <Ecommerce />
      <EcommerceOverview />
      <EcommercePillars />
      <KeywordIntent />
      <ProductCategorySeo />
      <TechnicalEcommerce />
      <Platforms />
      <ContentCompetitors />
      <Measurement />
      <AiDiscovery />
      <Process />
      <DirectConsultant />
      <Faq />
      <Ecommerceaudit />
      <Footer />
    </div>;
}